import React, { useState, useEffect } from "react";
import { Route, Navigate, Routes } from "./services/Router";
import { useLocation } from "react-router-dom";
import {
  NavigationBar,
  Login,
  ResetPassword,
  GroupsDashboardsNavDrawer,
  Dashboard,
  LoginCallback,
  USBTool,
} from "./containers";
import { isxOperations } from "./store";
import { connect } from "react-redux";
import "react-virtualized/styles.css";

import { DashboardsContextProvider } from "services/Utils";

const PrivateRouteComponent = ({ refresh, isAuthenticated, children }) => {
  const [loading, setLoading] = useState(true);

  const location = useLocation();

  useEffect(() => {
    (async () => {
      await refresh();
      setLoading(false);
    })();
  }, [refresh]);

  if (loading) {
    return null;
  }

  if (isAuthenticated) {
    return children;
  }

  return (
    <Navigate to="/login" state={{ from: { pathname: location.pathname } }} />
  );
};

const PrivateRoute = connect(
  ({ isx: { isAuthenticated } }) => ({ isAuthenticated }),
  (dispatch: any) => ({
    refresh: () => dispatch(isxOperations.attemptRefresh()),
  })
)(PrivateRouteComponent);

const App = (props) => {
  return (
    <DashboardsContextProvider>
      <NavigationBar logo={props.logo} />
      <Routes>
        <Route
          path="/dashboard/:dashboardGuuid?"
          element={
            <PrivateRoute>
              <GroupsDashboardsNavDrawer />
              <Dashboard />
            </PrivateRoute>
          }
        />
        <Route path="/" element={<LoginCallback />} />
        <Route path="/login" element={<Login />} />
        <Route path="/changepass" element={<ResetPassword />} />
        <Route path="/usbtool" element={<USBTool />} />
      </Routes>
    </DashboardsContextProvider>
  );
};

export default App;
